<template>
  <div class="addOnlineContainer">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="所属行业" prop="trade_id">
        <a-radio-group v-model="form.trade_id">
          <a-radio
            v-show="element.trade_name != '内部系统'"
            :value="element.id"
            v-for="(element, k) in tradeList"
            :key="k"
            >{{ element.trade_name }}</a-radio
          >
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="岗位名称" prop="name">
        <a-input v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item label="性别要求" prop="gender">
        <a-radio-group v-model="form.gender">
          <a-radio :value="1">
            男
          </a-radio>
          <a-radio :value="2">
            女
          </a-radio>
          <a-radio :value="3">
            不限
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="上班时间" prop="work_time">
        <a-input v-model="form.work_time" />
      </a-form-model-item>
      <a-form-model-item label="发薪时间" prop="pay_time">
        <a-input v-model="form.pay_time" />
      </a-form-model-item>
      <a-form-model-item label="预支" prop="advance">
        <a-input v-model="form.advance" />
      </a-form-model-item>
      <a-form-model-item label="硬性要求年龄" prop="age">
        <a-input v-model="form.age" />
      </a-form-model-item>
      <a-form-model-item label="硬性要求学历" prop="education">
        <a-input v-model="form.education" />
      </a-form-model-item>
      <a-form-model-item label="硬性要求征信" prop="credit_investigation">
        <a-input v-model="form.credit_investigation" />
      </a-form-model-item>
      <a-form-model-item label="是否培训" prop="is_train">
        <a-radio-group v-model="form.is_train">
          <a-radio :value="1">
            是
          </a-radio>
          <a-radio :value="2">
            否
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.is_train == 1"
        label="培训期薪资"
        prop="train_salary"
      >
        <a-input v-model="form.train_salary" />
      </a-form-model-item>
      <a-form-model-item label="岗位要求">
        <a-textarea
          v-model="form.requirement"
          placeholder="性别、年龄、其他要求"
          :autoSize="{ minRows: 3, maxRows: 5 }"
        />
      </a-form-model-item>
      <a-form-model-item label="岗位描述">
        <a-textarea
          placeholder="工作内容"
          v-model="form.describe"
          :autoSize="{ minRows: 3, maxRows: 5 }"
        />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button @click="clear" style="margin-right:20px">重置</a-button>
        <a-button type="primary" html-type="submit" @click="handleSubmit"
          >提交</a-button
        >
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      form: {
        name: "",
        trade_id: "",
        gender: "",
        work_time: "",
        pay_time: "",
        age: "",
        advance: "",
        education: "",
        credit_investigation: "",
        is_train: "",
        train_salary: "",
        requirement: "",
        describe: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入岗位名称",
            trigger: "blur"
          }
        ],
        trade_id: [
          {
            required: true,
            message: "请选择行业",
            trigger: "change"
          }
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change"
          }
        ],
        work_time: [
          {
            required: true,
            message: "请填写上班时间",
            trigger: "blur"
          }
        ],
        pay_time: [
          {
            required: true,
            message: "请填写发薪时间",
            trigger: "blur"
          }
        ],
        advance: [
          {
            required: true,
            message: "请填写预支",
            trigger: "blur"
          }
        ],
        age: [
          {
            required: true,
            message: "请填写硬性要求年龄",
            trigger: "blur"
          }
        ],
        education: [
          {
            required: true,
            message: "请填写硬性要求学历",
            trigger: "blur"
          }
        ],
        credit_investigation: [
          {
            required: true,
            message: "请填写硬性要求征信",
            trigger: "blur"
          }
        ],
        is_train: [
          {
            required: true,
            message: "请选择是否培训",
            trigger: "change"
          }
        ],
        train_salary: [
          {
            required: true,
            message: "请填写培训期薪资",
            trigger: "blur"
          }
        ]
      },
      tradeList: [],
      detail: {}
    };
  },
  mounted() {
    this.getTrade(); //获取行业
    if (this.editDetail != undefined) {
      this.getDetail(); //获取详情
    }
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetail(); //获取详情
      // console.log(this.detail);
    }
  },
  methods: {
    getDetail() {
      this.detail = this.editDetail;
      this.form = {
        name: this.detail.name,
        trade_id: this.detail.trade_id,
        gender: this.detail.gender,
        work_time: this.detail.work_time,
        requirement: this.detail.requirement,
        describe: this.detail.describe,
        pay_time: this.detail.pay_time,
        age: this.detail.age,
        advance: this.detail.advance,
        education: this.detail.education,
        credit_investigation: this.detail.credit_investigation,
        is_train: this.detail.is_train,
        train_salary: this.detail.train_salary
      };
    },
    getTrade() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "/Trade/tradeList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10000
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.tradeList = res.data.data.data;
          // console.log(this.tradeList);
        }
      });
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.recruitment +
            "Position/editPosition";
          let params = {
            id: this.detail.id,
            trade_id: this.form.trade_id,
            name: this.form.name,
            describe: this.form.describe,
            requirement: this.form.requirement,
            work_time: this.form.work_time,
            type: 1,
            gender: this.form.gender,
            pay_time: this.form.pay_time,
            age: this.form.age,
            advance: this.form.advance,
            education: this.form.education,
            credit_investigation: this.form.credit_investigation,
            is_train: this.form.is_train,
            train_salary: this.form.train_salary,
            token: window.localStorage.getItem("xnwfPcToken")
          };
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.$emit("hideInEdit", false);
                this.clear();
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    },
    clear() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
.addOnlineContainer {
  h2 {
    font-weight: normal;
    margin: 30px 0 20px 22%;
  }
  form {
    padding-bottom: 30px;
    padding-top: 50px;
  }
  .ant-form-item {
    margin-bottom: 10px;
  }
  .tips {
    background: rgba(255, 64, 129, 0.03);
    padding: 10px 0;
    li {
      padding: 0 10px;
      cursor: pointer;
      > div {
        line-height: 26px;
      }
      .address {
        font-size: 12px;
        color: #999;
        line-height: 20px;
      }
    }
    li:hover {
      background: #fff;
    }
  }
}
</style>
